var s = Object.defineProperty;
var r = (e, t, a) => t in e ? s(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a;
var l = (e, t, a) => (r(e, typeof t != "symbol" ? t + "" : t, a), a);
class c {
  /**
   * @constructor
   * @param {string} name 绑定的属性名
   * @param {string} label 标签名
   */
  constructor(t = "", a = "") {
    l(this, "name");
    l(this, "label");
    this.name = t, this.label = a;
  }
}
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/FormFieldAttr.js
// module id = 828
// module chunks = 41